// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 12a9 9 0 10-18 0 9 9 0 0018 0zm-4.23-.373l-3.857 3.857a1.288 1.288 0 01-1.826 0L7.23 11.627a1.29 1.29 0 111.826-1.826l2.713 2.726a.32.32 0 00.462 0l2.713-2.726a1.291 1.291 0 011.826 1.826z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;